import { createClient } from '@supabase/supabase-js';

// --- JURUS MULTI DOMAIN V44 ---
// 1. Cek apakah ada settingan dari cPanel (app-settings.js)?
// @ts-ignore
const externalConfig = (window as any).APP_CONFIG;

// 2. Kalau ada, pakai itu. Kalau tidak, pakai settingan bawaan (.env atau hardcode)
const supabaseUrl = externalConfig?.SUPABASE_URL || 'https://fjkpgmdxsfahfpuhwrbj.supabase.co';
const supabaseAnonKey = externalConfig?.SUPABASE_KEY || 'eyJhbgcioiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImZqa3BnbWR4c2ZhaGZwdWh3cmJqIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzUyMDI2MzMsImV4cCI6MjA1MDc3ODYzM30.OFyKjQyXJvXNlZk3uTjZzQxYlVvBqNmMkLpWhJtGvXc';

// 3. Cek keamanan biar Suhu sadar kalau lupa setting
if (!supabaseUrl || !supabaseAnonKey) {
  console.error('⚠️ BAHAYA: Koneksi Database GAGAL! Cek app-settings.js di cPanel.');
}

// 4. Buat sambungan
export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// --- TIPE DATA (JANGAN DIHAPUS) ---
export interface MaskedLink {
  id: string;
  created_at: string;
  title: string;
  description: string;
  target_url: string;
  bonus_link: string;
  og_image: string;
  short_code: string;
  clicks: number;
  user_id: string;
}